import { Badge } from '@/components/ui/badge'
import { EmailVerification } from '@/models/user'

const LABELS: Record<EmailVerification, string> = {
  [EmailVerification.VERIFIED]: 'Verified',
  [EmailVerification.UNVERIFIED]: 'Unverified',
}

const VARIANTS = {
  [EmailVerification.VERIFIED]: 'success',
  [EmailVerification.UNVERIFIED]: 'secondary',
} as const

/** Whether a member has proved their email, for staff. */
export function EmailVerificationBadge({ status }: { status: EmailVerification }) {
  return <Badge variant={VARIANTS[status]}>{LABELS[status]}</Badge>
}
